import { infrastructuresRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';
import { CreateInfrastructureCost } from '../types';

export const useCreateInfrastructureCost = () =>
  useMutation<void, unknown, CreateInfrastructureCost>((createInfrastructure) =>
    infrastructuresRepo.createInfrastructure(createInfrastructure),
  );
